<template>
    <div>
        <Header title="运势详情"/>
        <div class="date" v-if="false">
            <p>2021年7月</p>
            <img :src="Images.icon_arrow_down_blue" alt="">
        </div>
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight) + 'px' }"
        >
            <scroller
                :on-refresh="refresh"
                :on-infinite="infinite"
                :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <fortuneItem v-for="(item, index) in dataSources" :key="index" :item="item"/>
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </scroller>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header'
import fortuneItem from '@/components/item/fortuneItem'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header,
        'fortuneItem': fortuneItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 0,
            limit: 10,
            keyword: '',
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 方法 */
    methods: {
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        infinite() {
            this.page++
            setTimeout(() => {
                this.requestData();
            }, 500);
        },
        // 请求数据
        async requestData() {
            let url = this.API.destiny_list;
            let params = {
                page: this.page,
                limit: this.limit
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data.data;
                if (this.page === 1) {
                    this.dataSources = list
                } else {
                    this.dataSources = this.dataSources.concat(list)
                }
                this.$refs.infinite.finishInfinite(list.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        }
    },
};
</script>

<style lang="less" scoped>

.date {
    height: 44px;
    padding: 0 25px;
    background: #fff;
    display: flex;
    align-items: center;

    p {
        font-size: 15px;
        color: #333;
    }

    img {
        width: 10px;
        height: 8px;
        margin-left: 5px;
    }
}

.scrollerView {
    position: relative;
    // top: 44px;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}
</style>